import { FormErrors } from "redux-form";

import { ChangePasswordFormData } from "./ChangePasswordForm";
import {
    required,
    equal,
    validEmail,
    validPassword,
} from "../../../util/validators";
import { CreateLoginFormData } from "./CreateLoginForm";

const validateCreateLoginForm = (values: CreateLoginFormData) => {
    const errors: FormErrors<CreateLoginFormData> = {};
    errors.username = required(values.username);
    errors.password = validPassword(values.password);
    errors.verifyPassword = equal(values.password, values.verifyPassword);
    return errors;
};

export default validateCreateLoginForm;



// WEBPACK FOOTER //
// ./src/views/profile/components/CreateLoginValidator.ts